'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { cloneElement } from 'react';
import styled, { css } from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { Flex } from '../Flex/Flex.js';
import { Text } from '../Text/Text.js';

const StyledFlex = styled(Flex).withConfig({
  componentId: "sc-joee5e-0"
})(["", ""], ({
  width
}) => width && css(["width:", ";"], typeof width === 'string' ? width : `${width}px`));
const StyledIndicator = styled.circle.withConfig({
  componentId: "sc-joee5e-1"
})(["", ""], ({
  theme
}) => css(["stroke:", ";stroke-width:", ";"], theme.components.spinner.circleForeground.stroke, theme.components.spinner.strokeWidth));
const StyledTrack = styled.circle.withConfig({
  componentId: "sc-joee5e-2"
})(["", ""], ({
  theme
}) => css(["stroke:", ";stroke-width:", ";"], theme.components.spinner.circleBackground.stroke, theme.components.spinner.strokeWidth));
const SpinnerBase = /*#__PURE__*/withTitan(_a => {
  var {
      children,
      track = jsx(StyledTrack, {}),
      indicator = jsx(StyledIndicator, {}),
      testId = 'spinnerBase',
      size,
      viewBox = '0 0 100 100'
    } = _a,
    rest = __rest(_a, ["children", "track", "indicator", "testId", "size", "viewBox"]);
  const sharedDefaultAttrs = {
    cx: 50,
    cy: 50,
    fill: 'none',
    r: 40,
    strokeLinecap: 'round'
  };
  return jsxs("svg", Object.assign({
    "data-test-id": `${testId}Svg`,
    height: size,
    viewBox: viewBox,
    width: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    children: [cloneElement(track, Object.assign(Object.assign(Object.assign({}, sharedDefaultAttrs), track.props), {
      'data-test-id': `${testId}Track`
    })), ";", cloneElement(indicator, Object.assign(Object.assign(Object.assign({}, sharedDefaultAttrs), indicator.props), {
      'data-test-id': `${testId}Indicator`
    }), children), ";"]
  }));
}, {
  name: 'SpinnerBase'
});
const Spinner = /*#__PURE__*/withTitan(_a => {
  var {
      children,
      testId = 'spinner',
      size
    } = _a,
    rest = __rest(_a, ["children", "testId", "size"]);
  return jsxs(StyledFlex, Object.assign({
    alignItems: "center",
    "data-test-id": testId,
    flexDirection: "column",
    gap: 2
  }, rest, {
    children: [jsxs(SpinnerBase, {
      size: size,
      testId: testId,
      children: [jsx("animate", {
        attributeName: "stroke-dashoffset",
        dur: "3s",
        from: "502",
        repeatCount: "indefinite",
        to: "0"
      }), jsx("animate", {
        attributeName: "stroke-dasharray",
        dur: "3s",
        repeatCount: "indefinite",
        values: "150.6 100.4;1 250;150.6 100.4"
      })]
    }), children && jsx(Text, {
      isBlock: true,
      isTruncated: true,
      color: "grey70",
      type: "labelSmall",
      children: children
    })]
  }));
}, {
  name: 'Spinner'
});

export { Spinner, SpinnerBase };
//# sourceMappingURL=Spinner.js.map
